import { render, staticRenderFns } from "./ProcesoCompraAbonadosSga.vue?vue&type=template&id=34541576"
import script from "./ProcesoCompraAbonadosSga.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraAbonadosSga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports